import React from "react";
import MobileNav from "../../components/mobile/nav/MobileNav";
import Footer from "../../components/mobile/footer/Footer";
import MobileAgreementComponent from "../../components/mobile/register/Agreement";

export default function Agreement() {
  return (
    <>
      <MobileNav />
      <MobileAgreementComponent />
      <Footer />
    </>
  );
}
